import { call, put, takeLatest, delay, select } from "redux-saga/effects"
import { history } from "../helpers/history"
import { authHeader } from "../helpers/auth-header"
import { buildContentService } from "../services/build_content.services"
import axios from "../services/axios"
import { clearMultibase } from "../actions/multiAiBase"
import {
	REQUEST_SAVED_BUILD_CONCEPTS,
	SAVED_BUILD_CONCEPTS_SEARCHING_SUCCESS,
	UPDATE_LAST_CONCEPTS_CALL,
	TOPICBUILDER_SEARCHING,
	BULD_CONCEPT_LOADING_END,
	LOGOUT,
	SHOW_ALERT,
	TOPICBUILDER_SEARCH_ERROR,
	SAVED_INDIVIDUAL_BUILD_CONCEPTS_LOADED_SUCCESS,
	REQUEST_LOAD_CONCEPT_API,
	BUILD_CONCEPT_LIST_HIGHLIGHT_CONCEPTS,
	BUILD_CONCEPT_UNSAVED,
	BUILD_CONCEPT_SAVE_CURRENT_UUID,
	BUILD_CONCEPT_NEED_TO_REFESH_DOCUMENTS,
	BUILD_CONCEPT_SEARCHING_DOCS,
	BUILD_CONCEPT_FORCE_FILTER_REFRESH,
	BUILD_CONCEPT_FORCE_CLOUD_REFRESH,
} from "../types/index"
import { clearLocalStorage } from "../utils"

function* requestDocumentsList(value) {
	// dispatch(requestDocumentsList(true));
	yield put({
		type: BUILD_CONCEPT_NEED_TO_REFESH_DOCUMENTS,
		payload: value,
	})
	yield put({
		type: BUILD_CONCEPT_SEARCHING_DOCS,
		payload: value,
	})
}

const getConceptById = async (id) => {
	return await axios.get(`/concept/${id}`).catch((e) => console.log(e))
}

function* savedBuildConceptsFlow(action) {
	try {
		let payload = true
		yield put({ type: TOPICBUILDER_SEARCHING, payload })

		try {
			const conceptList = yield call(buildContentService.conceptList)
			yield put({
				type: SAVED_BUILD_CONCEPTS_SEARCHING_SUCCESS,
				payload: conceptList?.data?.concepts || [],
			})

			if (conceptList?.data?.concepts?.length > 0) {
				yield put({ type: UPDATE_LAST_CONCEPTS_CALL })
			}
			yield put({ type: BULD_CONCEPT_LOADING_END, payload: false })
		} catch (error) {
			try {
				if (error?.response?.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put({ type: LOGOUT })
					yield call(history.push, "/")
					return
				}
			} catch (e) {
				console.log(e)
			}
			//dispatch(requestConceptAPIError(true));
			yield put({ type: TOPICBUILDER_SEARCH_ERROR, payload: true })
			yield put({
				type: SHOW_ALERT,
				payload: {
					msg: "There was an error. Please, try again and check your connection",
					class: "alert alert-danger",
				},
			})
		}
	} catch (error) {
		// if the api call fails, it will "put" the UPDATEACCOUNTDETAILS_ERROR
		// into the dispatch along with the error.
		console.log(error)
		//yield put({ type: UPDATEACCOUNTDETAILS_ERROR, error })
	}
}

function* loadConceptApiFlow(action) {
	const { ext_id, refreshBuildHighlight } = action.payload
	const state = yield select()
	let payload = true
	yield put({ type: TOPICBUILDER_SEARCHING, payload })
	try {
		//Get from API
		const response = yield call(buildContentService.conceptIndividual, ext_id)
		// dispatch(loadIndividualContentAPISuccess(response.data.data));
		yield put({
			type: SAVED_INDIVIDUAL_BUILD_CONCEPTS_LOADED_SUCCESS,
			payload: response.data.concept,
		})
		//yield delay (100);
		if (refreshBuildHighlight) {
			try {
				let topicResult = yield select((state) => state.buildconcept.topicBuilderResults)
				//let topicResult = state.buildconcept.topicBuilderResults;
				let positiveSearch = topicResult.filter((i) => i[2] >= 0).map((i) => `${i[1]}`)
				let negativeSearch = topicResult.filter((i) => i[2] < 0).map((i) => `${i[1]}`)
				// dispatch(updateHighlightConcepts({positive: positiveSearch, negative: negativeSearch}));
				yield put({
					type: BUILD_CONCEPT_LIST_HIGHLIGHT_CONCEPTS,
					payload: { positive: positiveSearch, negative: negativeSearch },
				})
			} catch (e) {
				//console.log(e);
			}
		}
		// dispatch(setCurrentUUID(ext_id));
		yield put({
			type: BUILD_CONCEPT_SAVE_CURRENT_UUID,
			payload: ext_id,
		})
		// dispatch(setUnsaveData(false));
		yield put({
			type: BUILD_CONCEPT_UNSAVED,
			payload: false,
		})
		// dispatch(requestDocumentsList(true));
		//requestDocumentsList(true);
		yield put({
			type: BUILD_CONCEPT_NEED_TO_REFESH_DOCUMENTS,
			payload: true,
		})

		yield put({
			type: BUILD_CONCEPT_SEARCHING_DOCS,
			payload: true,
		})
		// dispatch(setCurrentSearchingDocs(false));
		yield put({
			type: BUILD_CONCEPT_SEARCHING_DOCS,
			payload: false,
		})
		// dispatch(setForceFilterRefresh(true));
		yield put({
			type: BUILD_CONCEPT_FORCE_FILTER_REFRESH,
			payload: true,
		})
		// dispatch(setForceCloudRefresh(true));
		yield put({
			type: BUILD_CONCEPT_FORCE_CLOUD_REFRESH,
			payload: true,
		})
	} catch (error) {
		console.log(error)
		try {
			if (error.response.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {
			console.log(e)
		}
		// dispatch(requestConceptAPIError(true));
		yield put({
			type: TOPICBUILDER_SEARCH_ERROR,
			payload: true,
		})
		// dispatch(alertActions.showAlertAction({
		//     msg: 'There was an error. Please, try again and check your connection',
		//     class: 'alert alert-danger'
		// }));
		let alert = {
			msg: "There was an error. Please, try again and check your connection",
			class: "alert alert-danger",
		}
		yield put({
			type: SHOW_ALERT,
			payload: alert,
		})
	}
}

// Watches for the UPDATEACCOUNTDETAILS_REQUESTING action type
// When it gets it, it will call verificarFlow()
// WITH the action we dispatched
function* conceptsWatcher() {
	// takeLatest() takes the LATEST call of that action and runs it
	// if we we're to use takeEvery, it would take every single
	// one of the actions and kick off a new task to handle it
	// CONCURRENTLY!!!
	yield takeLatest(REQUEST_SAVED_BUILD_CONCEPTS, savedBuildConceptsFlow)
	yield takeLatest(REQUEST_LOAD_CONCEPT_API, loadConceptApiFlow)
}

export default conceptsWatcher
